import Urls from '../urls/Urls';
import ParameterErrors from '../errors/ParameterErrors';
const {throwNotProvided}=ParameterErrors;
export default class PixelMappings{
    constructor(props) {
        const { mapAToBToGToRToValue, imageFileRelativePath, configuration} = props;
		this._configuration = configuration;
        this._mapAToBToGToRToValue = mapAToBToGToRToValue;
        this._imageFileRelativePath = imageFileRelativePath;
		this._canvas = document.createElement('canvas');
		this.initialize = this.initialize.bind(this);

		this.getValueFromPercentages = this.getValueFromPercentages.bind(this);
		this.getValueFromProportions = this.getValueFromProportions.bind(this);
		this.getValueFromPixel = this.getValueFromPixel.bind(this);
		this._getPixelARGB=this._getPixelARGB.bind(this);
		this._checkInitialized = this._checkInitialized.bind(this);
		this._initialized = false;
    }
	get initialized(){
		return this._initialized;
	}
	initialize(){
		return new Promise((resolve, reject)=>{
			if(this._initialized)throw new Error('Already initialized');
			
			const img = document.createElement('img');
			img.crossOrigin = "Anonymous";
			img.src = Urls.getAssetsForSite(this._configuration.siteSlug)+this._imageFileRelativePath;
			img.addEventListener('load', ()=>{
				this._initialized=true;
				this._canvas.width = img.width;
				this._canvas.height = img.height;
				this._canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
				resolve();
			});
			img.addEventListener('error', (err)=>{
				reject(err);
			});
		});
	}
	_checkInitialized(){
		if(!this._initialized)throw new Error('Not initialize');
	}
	getValueFromPercentages(xPercent, yPercent){
		return this.getValueFromProportions(xPercent/100, yPercent/100);
	}
	getValueFromProportions(xProportion, yProportion){
		const x = parseInt(xProportion*this._canvas.width);
		const y = parseInt(yProportion*this._canvas.height);
		return this.getValueFromPixel(x, y);
	}
	getValueFromPixel(x, y){
		if(isNaN(x)||isNaN(y))return null;
		const rgba = this._getPixelARGB(x, y);
		const mapBToGToRToValue = this._mapAToBToGToRToValue[rgba[3]];
		if(!mapBToGToRToValue)return null;
		const mapGToRToValue = mapBToGToRToValue[rgba[2]];
		if(!mapGToRToValue)return null;
		const mapRToValue = mapGToRToValue[rgba[1]];
		if(!mapRToValue)return null;
		const value = mapRToValue[rgba[0]];
		return value;
	}
	_getPixelARGB(x, y){
		this._checkInitialized();
		if(x<0)x=0;
		else if(x>=this._canvas.width)x=this._canvas.width-1;
		if(y<0)y=0;
		else if(y>=this._canvas.height)y=this._canvas.height-1;
		const pixelData = this._canvas.getContext('2d').getImageData(x, y, 1, 1).data;
		return pixelData;
	}
	static _parseRgbaValuePairsToMap(rgbaValuePairs){
		const mapAToBToGToRToValue = {};
		rgbaValuePairs.forEach((rgbaValuePair)=>{
			const rgba = rgbaValuePair.rgba;
			const mapBToGToRToValue=mapAToBToGToRToValue[rgba.a];
			if(!mapBToGToRToValue){
				mapAToBToGToRToValue[rgba.a]={
					[rgba.b]:{
						[rgba.g]:{
							[rgba.r]:rgbaValuePair.value
						}
					}
				};
				return;
			}
			const mapGToRToValue=mapBToGToRToValue[rgba.b];
			if(!mapGToRToValue){
				mapBToGToRToValue[rgba.b]={
					[rgba.g]:{
						[rgba.r]:rgbaValuePair.value
					}
				};
				return;
			}
			const mapRToValue=mapGToRToValue[rgba.g];
			if(!mapRToValue){
				mapGToRToValue[rgba.g]={
					[rgba.r]:rgbaValuePair.value
				};
				return;
			}
			mapRToValue[rgba.r] = rgbaValuePair.value;
		});
		return mapAToBToGToRToValue;
	}
    static fromJSON(jObject, configuration) {
		const rgbaValuePairs=jObject.rgbaValuePairs;
		if(rgbaValuePairs===undefined||rgbaValuePairs===null)
			throwNotProvided('rgbaValuePairs');
		const imageFileRelativePath= jObject.imageFileRelativePath;
		if(imageFileRelativePath===undefined||imageFileRelativePath===null)
			throwNotProvided('imageFileRelativePath');
		const mapAToBToGToRToValue = PixelMappings._parseRgbaValuePairsToMap(rgbaValuePairs);
		return new PixelMappings({mapAToBToGToRToValue:mapAToBToGToRToValue, imageFileRelativePath:imageFileRelativePath, configuration});
    }
}